import {Principle} from "../modules/brand_service/model/Principle";
import {getAbsoluteUrl} from "../modules/utils/urlUtill";
import {handle403} from "../modules/main/factory/global_40e_handler";


export function globalFetch<T>(url: string,
                               method: string,
                               data?: any,
                               headers: Record<string, string> = {}): Promise<T> {

    return fetch(url, {
        method: method,
        body: data,
        headers: headers,
        credentials: "include",
        cache: "no-cache",
    })
        .then(resp => {
            if (resp.status == 403) {
                handle403();
            }
            return resp.json();
        })
        .catch(err => {
            if (err.status === 403) {
                handle403();
            }
        })
}


class ActiveBrandInitializer {
    private brandIsResolved: boolean;
    private fetchPrinciplePromise: Promise<Principle>;
    private principle: Principle;

    constructor() {
        this.brandIsResolved = false;
        this.fetchPrinciplePromise = this.fetchPrinciple();
    }

    assertResolvedAndGetPrinciple = () => {
        return this.principle;
    };

    getPrinciple = async (): Promise<Principle> => {
        if (this.brandIsResolved) {
            return Promise.resolve(this.principle);
        } else {
            return await this.fetchPrinciplePromise;
        }
    };


    fetchPrinciple = (): Promise<Principle> => {
        return globalFetch(getAbsoluteUrl('principal'), 'GET')
            .then((resp: Principle) => {
                this.brandIsResolved = true;
                this.principle = resp;
                return resp;
            });

    }


}

export const CONFIGURATION_INITIALIZER = new ActiveBrandInitializer();